import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ProductValidationSchema } from '@/features/products/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'

interface UseCreateProductProps {
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: AxiosError) => void
}

export const useCreateProduct = ({ onSuccess, onError }: UseCreateProductProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createProduct'],
    mutationFn: async (form: ProductValidationSchema) => {
      const haveTefIdentifiers =
        form.product_tef_identifiers?.length &&
        form.product_tef_identifiers?.some((tefIdentifier) => !!tefIdentifier?.identifier)

      const product = {
        ...form,
        category_id: form.category.value,
        unit_for_quantity: form.unit_for_quantity.value,
        product_tef_identifiers_attributes: haveTefIdentifiers
          ? form.product_tef_identifiers
              ?.filter((tefIdentifier) => !!tefIdentifier.tef_provider?.value && !!tefIdentifier?.identifier)
              ?.map((tefIdentifier) => ({
                tef_provider: tefIdentifier.tef_provider?.value,
                identifier: tefIdentifier.identifier,
              }))
          : null,
        equipment_category_ids: haveTefIdentifiers
          ? form.equipment_category_ids?.map((equipmentCategory) => equipmentCategory.value)
          : null,
        equipment_tier_id: form.equipment_tier?.value || null,
        fiscal_document_kind: form.fiscal_document_kind?.value || 'none',
      }

      return await privateAxios.post('/products', {
        product,
      })
    },
    onSuccess,
    onError,
  })
}
